// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function register(config) {
  if ('serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(import.meta.env.BASE_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${import.meta.env.BASE_URL}service-worker.js`;
      const devSwUrl = `${import.meta.env.BASE_URL}service-worker-dev.js`;

      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(devSwUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then((sw) => {
          sw.addEventListener('message', (event) => {
            debugger;
          })
          console.log(
            'This web app is being served cache-first by a service ' +
              'worker. To learn more, visit https://bit.ly/CRA-PWA'
          );
        });

        //test
        navigator.serviceWorker.addEventListener('message', (event) => {
          debugger;
        })
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
      }
    });
  }
}


//check fo update every 5 min
let numCheck = 0;
function step(timestamp, registration) {
  let newNumcheck = Math.floor(timestamp/30000);

  if (numCheck !== newNumcheck) {
    console.log('check for update:', newNumcheck)
    registration.update();
    numCheck = newNumcheck;
  }
  window.requestAnimationFrame(timestamp => { step(timestamp, registration) })
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {

      //start check for update loop
      console.log('start init interval every 5 min')
      window.requestAnimationFrame(timestamp => { step(timestamp, registration) })

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        console.log('installingWorker.state', installingWorker.state)
        installingWorker.onstatechange = () => {
          console.log('installingWorker.state', installingWorker.state)
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              console.log(
                'New content is available and will be used when all ' +
                  'tabs for this page are closed. See https://bit.ly/CRA-PWA.'
              );

              // Execute callback
              //set active service worker for clear on update
              if (config && config.onUpdate) {
                config.onUpdate(registration, false);
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log('Content is cached for offline use.');

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }

          if (installingWorker.state === 'activated') {
            // Execute callback
            if (config && config.onActivated) {
              console.log('service worker activated');
              config.onActivated();
            }
          }
        };
      };

      // Check if there is a pending update
      const waitingWorker = registration.waiting;
      if (waitingWorker) {
        if (waitingWorker.state === 'installed') {
          if (navigator.serviceWorker.controller) {

            // At this point, the updated precached content has been fetched,
            // but the previous service worker will still serve the older
            // show update module.
            console.log(
              'New content is available and will be used when all ' +
                'ge are clotabs for this pased. Show update module See https://bit.ly/CRA-PWA.'
            );

            // Execute Callback
            //automatically update sw on first loag if aleady precachhed update
            if (config && config.onUpdate) {
              console.log('skip waiting update, start update interval');
              config.onUpdate(registration, true);
            }

            //automatically update sw on first loag if aleady precachhed update
            //waitingWorker.postMessage({ type: 'SKIP_WAITING' })
          }
        }
      }
    })
    .catch(error => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then(response => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        'No internet connection found. App is running in offline mode.'
      );
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error(error.message);
      });
  }
}
